import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WalletService } from "../services/wallet.service";
import * as firebase from "firebase";

@Injectable()
export class EscrowService {
  marketpayCo: any;
  watafanCo: any;
  fee_amount: string;
  apiUrl: any;

  constructor(public http: HttpClient, private walletService: WalletService) {
    console.log("Hello EscrowServiceProvider Provider");
    firebase
      .database()
      .ref("/prod_comissions")
      .once("value")
      .then(snapshot => {
        if (snapshot.val()) {
          this.marketpayCo = snapshot.val().marketpay;
          this.watafanCo = snapshot.val().watafan;
          this.apiUrl = snapshot.val().url;
          console.log(
            "marjketpayCom " +
              this.marketpayCo +
              "watafan Comission " +
              this.watafanCo +
              " urlapi " +
              this.apiUrl
          );
        }
      });
  }

  postExpress(amount: string) {
    var address: string = this.walletService.getAddress();
    var totalamount = this.calculateCommissions(amount);
    var $data = JSON.stringify(
      this.generateData(address, totalamount.toString())
    );

    console.log("json" + $data);
    var apiUrl = this.apiUrl;

    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    };

    return new Promise((resolve, reject) => {
      this.http.post(apiUrl, $data, httpOptions).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
  //vacio phone, settlor_confirmed_url and settlor_denied_url vacio
  generateData(address, amount) {
    return {
      name: "Compra watafan",
      amount: amount,
      source: "watafan",
      trustee_confirmed_url: "https://app.watafan.com/",
      trustee_denied_url: "https://app.watafan.com/",
      settlor_confirmed_url: "https://app.watafan.com/",
      settlor_denied_url: "https://app.watafan.com/",
      tag: address,
      fee_amount: this.fee_amount
    };
  }

  calculateCommissions(amount) {
    var comission: number;
    var amountCo: number;
    var percentBuyer: number;
    var totalAmount: number;
    var buyamount = parseFloat(amount);

    comission = parseFloat(this.marketpayCo) + parseFloat(this.watafanCo);
    console.log("Comission " + comission);
    percentBuyer = 100 - comission;
    console.log("Percent buyer : " + percentBuyer);
    amountCo = (buyamount * (comission / 100)) / (percentBuyer / 100);
    console.log("Comissions amount " + amountCo);
    this.fee_amount = amountCo.toString();
    totalAmount = buyamount + amountCo;
    console.log("Tolta Amount " + totalAmount);
    return totalAmount;
  }
}



// WEBPACK FOOTER //
// ./src/services/escrow.service.ts